import {Component, Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { FeedService } from './feed.service';
import { FeedEntry } from './model/feed-entry';

import { Http, URLSearchParams } from '@angular/http';

import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import * as Parser from 'rss-parser'

//declare let ga: Function;

// Statics
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/of';

// Operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/merge';
import 'rxjs/add/operator/do';

import {NgxAdDfpService} from './model/ngx-ad-dfp-service';

declare var googletag: any;


@Injectable()
export class DopTermService {
  constructor(private _http: Http) {}

  private results: Object;
  search(term: string) {
    if (term === '') {
      return Observable.of([]);
    }

    let wikiUrl = 'https://4hb3d9itb2.execute-api.us-east-1.amazonaws.com/prod/getdopentries';

    let params = new URLSearchParams();
    params.set('q', encodeURI(term));
    params.set('limit', '55');

    return this._http
        .get(wikiUrl, {search: params})
        .map(data => data.json()[1]);

  }
}

@Injectable()
export class MarkLogicService {

  constructor(private http: Http) {
    console.log('MarkLogic Service is available...');
  }

  makeDopRequest(url: string) {
    return this.sendDopRequest(url);
  }

  private sendDopRequest(url: string) {
    return this.http.get(url)
  }

}


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [DopTermService, MarkLogicService]
})




export class AppComponent {
  model: any = '';
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  exist = true;

  private feedUrl: string = 'http%3A%2F%2Fwww.apa.org%2Fnews%2Fpsycport%2Fpsycport-rss.xml';
  // feeds: Array<FeedEntry> = [];
  feeds: Array<any> = [];

  constructor(
      private _termservice: DopTermService,
      private ml: MarkLogicService,
      private _sanitizer: DomSanitizer,
      public http: Http,
      private route: ActivatedRoute,
      private router: Router,
      private feedService: FeedService,
      private meta: Meta,
      private titleService: Title
  ) {

  }


  search = (text$: Observable<string>) =>
      text$
          .debounceTime(300)
          .distinctUntilChanged()
          .do(() => this.searching = true)
          .switchMap(term =>
              this._termservice.search(term)
                  .do(() => {
                      this.model = term;
                      this.searchFailed = false;
                  })
                  .catch(() => {
                    this.searchFailed = true;
                    return Observable.of([]);
                  }))
          .do(() => this.searching = false)
          .merge(this.hideSearchingWhenUnsubscribed);

  //private router:Router;

  aToZ = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

  todImages = ['2-puzzle-pieces-2000','2-sided-tree-2000','3-decisions-2000','3-stacked-expression-boxes-2000','abstract-geometric-texture-2000','abstract-illusion-tree-2000','abstract-network-2000','abstract-portrait-montage-2000','abstract-thinking-illustration-2000','abstract-watercolor-head-2000','afternoon-sunset-2000','aging-brain-tree-2000','antelope-canyon-2000','apple-self-image-2000','artistic-painted-faces-2000','balance-stones-on-cliff-2000','balancing-stones-2000','birds-on-a-wire-2000','blue-brain-neurons-2000','blue-watercolor-person-2000','brain-creativity-illustration-2000','brain-dna-2000','capturing-glowing-brain-2000','child-mood-paper-2000','child-with-brain-sketch-2000','circuit-board-profiles-2000','cloud-head-lady-2000','cloud-man-with-hat-2000','cloud-painting-profile-2000','colorful-silhouettes-2000','colors-of-the-mood-2000','crossing-bridge-in-fog-2000','dock-at-sunrise-2000','emotion-colored-discs-2000','emotion-stones-2000','emotional-balloons-2000','emotional-intelligence-coffee-2000','expressive-wooden-puppet-2000','face-and-bridge-2000','face-fragments-woman-2000','finger-brain-space-2000','flower-growing-through-cracked-concrete-2000','flower-in-darkness-2000','flying-rocking-horse-2000','geometry-of-soul-2000','girl-clouds-2000','girl-profile-and-red-clouds-2000','girl-profile-blue-green-clouds-2000','girl-with-3-masks-2000','girl-with-emotion-icons-2000','glowing-person-sky-2000','glowing-puzzle-head-2000','growing-daisy-2000','hanging-light-bulb-2000','happy-egg-2000','head-of-gears-2000','head-of-puzzle-2000','head-of-puzzle-pieces-2000','head-with-head-inside-2000','heart-mind-skateboard-2000','heart-shaped-tree-2000','holding-glowing-brain-2000','human-emotion-tree-2000','humanity-portrait-2000','i-can-do-it-2000','iceburg-2000','illustrated-left-right-brain-2000','illustrated-thought-processes-brain-2000','illustration-of-head-with-gears-2000','independent-plane-2000','lady-thinking-2000','left-and-right-brain-2000','lightbulb-with-brain-2000','lightbulbs-and-lady-2000','lit-up-brain-2000','man-at-crossroads-2000','man-on-cliff-2000','meditating-on-cliff-2000','memory-loss-gears-2000','memory-loss-tree-profile-2000','mental-health-2000','neurons-in-brain-2000','nuts-and-bolds-head-2000','orange-in-crowd-of-blue-2000','painted-profile-splatter-2000','painted-rock-brain-2000','path-of-life-2000','pawn-king-shadow-2000','people-in-confusion-2000','portrait-and-fractal-elements-2000','portrait-and-watercolor-2000','portrait-with-inner-child-2000','positive-thinking-abstract-2000','power-pose-morning-2000','profile-color-paper-brain-2000','psychology-illustration-2000','psychology-terms-in-mind-2000','puzzle-head-chalkboard-2000','puzzle-network-2000','rainbow-grunge-background-2000','red-gear-head-2000','road-bridge-sunset-2000','sad-child-2000','sad-red-person-2000','seedling-to-tree-2000','silhouette-chalboard-brain-2000','sitting-on-dock-2000','smiling-coffee-2000','social-psych-concept-2000','split-expression-face-2000','split-personality-2000','sunset-with-birds-2000','tetris-brain-2000','therapist-talking-2000','thoughts-in-bubble-2000','thread-silhouette-2000','universal-mind-2000','virtual-reality-2000','watercolor-empowerment-2000','watercolor-individual-among-group-2000','watercolor-inspiration-2000','well-being-compass-2000','woman-brain-etc-2000','yarn-idea-2000','zen-beach-2000'];

  todDef;

  todaysDate = new Date();

  formatter = (x) => x;

  location = this.router;
  public id:any[] = [];

  ngOnInit() {

    this.refreshFeed();
    this.getDopTod();

  }

  ngAfterViewInit() { //Ad script to load after the view gets initialised
    this.id = [`div-gpt-ad-1582927165062-0`,`div-gpt-ad-1582927165042-0`,`div-gpt-ad-1582927165035-0`];
    // Prevent from JS Errors if googletag is not defined
    if (typeof googletag !== 'undefined') {
     NgxAdDfpService.defineAds(googletag);
      this.showAd(this.id);
   }
  }

  // Slot allocation for ads
showAd(adSlots): void {
  adSlots.forEach(element => {
    googletag.cmd.push(() => {
      googletag.display(element);
    });
  });
}

  openBrowse(letter) {
    this.router.navigate(['/browse/',letter]);
    //this.gasend('/browse/'+letter, 'Browse by '+letter+' - APA Dictionary of Psychology', 'https://dictionary.apa.org/browse/'+letter);

    var element = document.getElementById("headerContentSlim");
    element.scrollIntoView();
  }


  openBrowseSymbols() {
    this.router.navigate(['/browse/', 'special-character-number']);
    //this.gasend('/browse/special-character-number', 'Browse by special character number - APA Dictionary of Psychology', 'https://dictionary.apa.org/browse/special-character-number');

    var element = document.getElementById("headerContentSlim");
    element.scrollIntoView();
  }

  clearSearch() {
    this.model = '';
    this.exist = true;
    this.router.navigate(['/']);
    this.setTitle();
  }

  selectedItem(item){
    this.model = '';
    this.exist = true;

    window.location.href = '/' + this.slugifyTerm(item.item);
  }

    goToTerm(model) {
      if(model) {
        window.location.href = '/' + this.slugifyTerm(model);
      } else {
        this.exist = false;
      }
    }



  getDopTod(): void {
    this.ml.makeDopRequest('https://4hb3d9itb2.execute-api.us-east-1.amazonaws.com/prod/getdoptermofday')
        .subscribe(data => {
          this.todDef = this._sanitizer.bypassSecurityTrustHtml(data["_body"]);
        });
  }

  refreshFeed() {
    this.feeds.length = 0;

    setTimeout(() => {
      let parser = new Parser();
      parser.parseURL('https://www.apa.org/news/psycport/psycport-rss.xml')
        .then(res => {
          this.feeds = res.items;
          console.log('then', res);
        }).catch (err => {
          console.log(err);
        })
    }, 1000);

    // // Adds 1s of delay to provide user's feedback.
    // this.feedService.getFeedContent().delay(1000)
    //     .subscribe(
    //         feed => this.feeds = feed.items,
    //         error => console.log(error));
  }

  slugifyTerm(term) {

    var trans1 = String(term).replace(/<[^\w\s–\-]+>/g, '').toLowerCase();
    var trans2 = String(trans1).replace(/\’/g, '');
    var trans3 = String(trans2).replace(/\s/g, '-');
    var trans4 = String(trans3).replace(/\-\(.*\)$/, '');
    var trans5 = String(trans4).replace(/[′]/g, '');
    var trans6 = String(trans5).replace(/\./g, '');
    var trans7 = String(trans6).replace(/\*/g, '');

    var trans8 = String(trans7).replace(/[é]/g, 'e');
    var trans9 = String(trans8).replace(/[è]/g, 'e');
    var trans10 = String(trans9).replace(/[ê]/g, 'e');
    var trans11 = String(trans10).replace(/[ë]/g, 'e');
    var trans12 = String(trans11).replace(/[ö]/g, 'o');
    var trans13 = String(trans12).replace(/[/]/g, '');
    var trans14 = String(trans13).replace(/[á]/g, 'a');
    var trans15 = String(trans14).replace(/[à]/g, 'a');
    var trans16 = String(trans15).replace(/[ä]/g, 'a');
    var trans17 = String(trans16).replace(/[š]/g, 's');
    var trans18 = String(trans17).replace(/[ü]/g, 'u');
    var trans19 = String(trans18).replace(/[…]/g, '');
    var trans20 = String(trans19).replace(/[&]/g, '');
    var trans21 = String(trans20).replace(/[→]/g, '');
    var trans22 = String(trans21).replace(/[+]/g, '-plus');
    var trans23 = String(trans22).replace(/[Š]/g, 's');
    var trans24 = String(trans23).replace(/[δ]/g, '-delta');
    var trans25 = String(trans24).replace('x̄', 'x-bar');
    var trans26 = String(trans25).replace(/[’]/g, '');
    var trans27 = String(trans26).replace(/[,]/g, '');
    var trans28 = String(trans27).replace(/[–]/g, '-');
    var trans29 = String(trans28).replace(/[=]/g, '-');
    var trans30 = String(trans29).replace(/[\(\)]/g, '');
    var trans31 = String(trans30).replace(/\-\-/g, '-');
    var trans32 = String(trans31).replace(/‘/g, '');
    var trans33 = String(trans32).replace(/:/g, '');
    return trans33

  }


  public setTitle() {
    this.titleService.setTitle('APA Dictionary of Psychology');
  }

/*  public gasend(gaPage, gaTitle, gaLocation){
    ga('create',"UA-10493335-13","auto");
    ga('send', {
      hitType: 'pageview',
      page: gaPage,
      title: gaTitle,
      location : gaLocation
    });
  }*/
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/app/app.component.ts